import React from 'react';
import { ChevronRight, Users2 } from 'lucide-react';
import PanelAvatar from '../../components/PanelAvatar';
import { dateLabel } from '../users/model';
import { Circle, sizeLabel, sizeText } from './model';
export function CircleAvatar({
  name,
  url
}: {
  name: string;
  url: string | null;
}) {
  return <PanelAvatar
    name={name}
    url={url}
    className="circle-avatar w-11 h-11 shrink-0 rounded-xl bg-lifeshare-100 text-lifeshare-700 inline-flex items-center justify-center font-semibold overflow-hidden"
  />;
}
export const circleDate = (value: string | null) => dateLabel(value, true, 'tr-TR');
export default function CircleList({
  circles,
  open,
  cards
}: {
  circles: Circle[];
  open: (circle: Circle) => void;
  cards: boolean;
}) {
  if (!circles.length) return <div className="bg-white border border-gray-100 rounded-2xl p-12 text-center">
    <Users2 className="mx-auto text-gray-300" />
    <h2 className="font-semibold mt-3">Çevre bulunamadı</h2>
    <p className="text-sm text-gray-500 mt-2">Aramayı veya filtreleri değiştirebilirsiniz.</p>
  </div>;
  return <>
    <div className={cards ? 'hidden' : 'hidden xl:block bg-white rounded-2xl border border-gray-100 overflow-hidden'}>
      <table className="w-full text-sm text-left">
        <thead className="bg-gray-50 text-xs text-gray-500">
          <tr>
            {['Çevre', 'Sahip', 'Üyeler', 'Oluşturulma', 'Detaylar'].map(label => <th key={label} className="p-4 font-medium">
              {label}
            </th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {circles.map(circle => <tr key={circle.id} className="circle-record" data-size={sizeLabel(circle.member_count)}>
            <td className="p-4">
              <button className="flex gap-3 text-left items-center" onClick={() => open(circle)}>
                <CircleAvatar name={circle.name} url={circle.avatar_url} />
                <span className="min-w-0">
                  <strong className="block truncate max-w-[230px]">
                    {circle.name}
                  </strong>
                  <span className="block text-xs text-gray-500 truncate max-w-[230px]">
                    {circle.description || 'Açıklama yok'}
                  </span>
                  <span className="text-xs text-gray-400">
                    #
                    {circle.id}
                  </span>
                </span>
              </button>
            </td>
            <td className="p-4">
              {circle.owner_name || 'Sahip bilinmiyor'}
              <span className="block text-xs text-gray-400">
                Kullanıcı #
                {circle.owner_id}
              </span>
            </td>
            <td className="p-4">
              {circle.member_count}
              <span className="block text-xs text-gray-500">
                {sizeText(circle.member_count)}
              </span>
            </td>
            <td className="p-4 text-xs text-gray-500">
              {circleDate(circle.created_at)}
            </td>
            <td className="p-4">
              <button className="user-btn" onClick={() => open(circle)} aria-label={`${circle.name} çevresini aç`}>
                Görüntüle
                <ChevronRight size={16} />
              </button>
            </td>
          </tr>)}
        </tbody>
      </table>
    </div>
    <div className={`${cards ? 'grid' : 'grid xl:hidden'} grid-cols-1 md:grid-cols-2 gap-3`}>
      {circles.map(circle => <article key={circle.id} data-size={sizeLabel(circle.member_count)} className="circle-record bg-white border border-gray-100 rounded-2xl p-4 min-w-0">
        <button className="flex gap-3 text-left w-full min-w-0" onClick={() => open(circle)}>
          <CircleAvatar name={circle.name} url={circle.avatar_url} />
          <span className="min-w-0">
            <strong className="block truncate">
              {circle.name}
            </strong>
            <span className="text-xs text-gray-500">
              {`#${circle.id} · ${circle.member_count} üye · ${sizeText(circle.member_count)}`}
            </span>
          </span>
        </button>
        <p className="text-sm text-gray-500 mt-3 break-words">
          {circle.description || 'Açıklama yok'}
        </p>
        <dl className="grid grid-cols-2 gap-3 text-xs mt-4 border-t border-gray-100 pt-3">
          <div>
            <dt className="text-gray-400">Sahip</dt>
            <dd className="mt-1 break-words">
              {circle.owner_name || 'Sahip bilinmiyor'}
              <span className="block text-gray-400">
                Kullanıcı #
                {circle.owner_id}
              </span>
            </dd>
          </div>
          <div>
            <dt className="text-gray-400">Oluşturulma</dt>
            <dd className="mt-1">
              {circleDate(circle.created_at)}
            </dd>
          </div>
        </dl>
        <button className="user-btn mt-4 w-full" onClick={() => open(circle)}>
          Çevreyi görüntüle
          <ChevronRight size={16} />
        </button>
      </article>)}
    </div>
  </>;
}
